import { useMutation } from '@apollo/client';
import { DELETE_CREATIVE_PACKAGE } from '../../graphql/mutations/creativeMutations';

/**
 * Hook to delete a Creative Package.
 * Package–project links for this package are typically cascade-deleted by the backend.
 * @returns {object} - { handleDeletePackage, loading, error }
 */
export const useDeleteCreativePackage = () => {
  const [deletePackageMutation, { loading, error }] = useMutation(DELETE_CREATIVE_PACKAGE, {
    refetchQueries: ['CreativePackagesByCreativeID', 'GetCreative'],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleDeletePackage = async (packageData) => {
    try {
      if (!packageData?.id) {
        throw new Error('Das Paket konnte nicht zugeordnet werden. Bitte lade die Seite neu und versuche es erneut.');
      }

      const input = sanitizeInput({
        id: packageData.id
      });

      const variables = sanitizeInput({
        input,
        condition: packageData?.condition
      });

      const { data: packageResponse } = await deletePackageMutation({
        variables
      });

      return packageResponse?.deleteCreativePackage;
    } catch (error) {
      console.error('Error deleting creative package:', error);
      throw error;
    }
  };

  return {
    handleDeletePackage,
    loading,
    error
  };
};
